import { Component, inject, OnInit } from '@angular/core';
import { AdminSidebar } from "../admin-sidebar/admin-sidebar";
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-admin-page',
  imports: [AdminSidebar, RouterOutlet],
  templateUrl: './admin-page.html',
  styleUrl: 'admin-page.scss',
})
export class AdminPage implements OnInit {

  private router = inject(Router);
  
  ngOnInit(): void{
    // La redirection est maintenant gérée par la route par défaut
  }
}
